<template>
  <b-modal ref="addItemModal"
           id="modal-edit-contact"
           title="Редактировать контакт"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-name">
        <b-form-input id="name"
                        type="text"
                        placeholder="Введите Имя"
                        v-model="editForm.name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-phone">
        <b-form-input id="phone"
                        type="tel"
                        placeholder="Введите телефон"
                        v-model="editForm.phone"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-email">
        <b-form-input id="email"
                        type="email"
                        placeholder="Введите почту"
                        v-model="editForm.email"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-title">
        <b-form-input id="title"
                        type="text"
                        placeholder="Введите должность"
                        v-model="editForm.title"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-questions">
        <b-form-input id="questions"
                        type="text"
                        placeholder="Введите вопросы"
                        v-model="editForm.questions"
                        >

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-sort">
        <b-form-input id="sort"
                        type="number"
                        placeholder="Введите порядок (больше — выше)"
                        v-model="editForm.sort"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-pic">
        <picture-input ref="pictureInput"
        width="200"
        height="200"
        margin="8"
        accept="image/*"
        size="10"
        :removable="true"
        :prefillOptions="{mediaType: 'image/*'}"
        :prefill="editForm.photo"
        :customStrings="{
          upload: '<h1>Перетащите изображение</h1>',
          drag: 'Перетащите изображение',
          change: 'Заменить фото',
          remove: 'Удалить фото',
        }"
        
        >
        </picture-input>
      </b-form-group>
      <b-form-group id="form-title-group-group" label="Группа">
        <b-form-select id="group"
                        type="text"
                        placeholder="Группа контактов"
                        v-model="editForm.group"
                        :options="groups"
                        required>

        </b-form-select>
      </b-form-group>
      <b-button type="submit" variant="success">Изменить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';
import PictureInput from 'vue-picture-input';

export default {
  components: {
    alertMsg,
    PictureInput,
  },
  name: 'modalEdit',
  data() {
    return {
      editForm: {
        email: '',
        questions: '',
        name: '',
        phone: '',
        title: '',
        group: '',
        photo: '',
        file: '',
        sort: '',
      },
      alertMessage: 'Error',
      showAlert: false,
      groups: [],
    };
  },
  computed: {
    ...mapState({
      editing_item: state => state.contacts.editing_item,
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    editItem(payload) {
      this.showAlert = false;
      const id = 'modal-edit-contact';
      const path = this.host + 'edit_contact';
      axios.post(path, payload, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('contacts');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    take_groups() {
      this.showAlert = false;
      const path = this.host + 'take_contact_groups';
      axios.post(path, {}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.groups = res.data.groups;
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = {
        'id' : this.editing_item.id,
        'email' : this.editForm.email,
        'questions' : this.editForm.questions,
        'name' : this.editForm.name,
        'title' : this.editForm.title,
        'phone' : this.editForm.phone,
        'group' : this.editForm.group,
        'sort' : this.editForm.sort,
      };
      if (this.$refs.pictureInput.file !== undefined){
        payload.photo = this.$refs.pictureInput.image;
        payload.photo_name = this.$refs.pictureInput.file.name;
      }
      this.editItem(payload);
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-edit-contact');
      this.initForm();
    },
    initForm() {
      this.editForm.email = this.editing_item.email;
      this.editForm.questions = this.editing_item.questions;
      this.editForm.name = this.editing_item.name;
      this.editForm.phone = this.editing_item.phone;
      this.editForm.title = this.editing_item.title;
      this.editForm.photo = this.editing_item.photo;
      this.editForm.sort = this.editing_item.sort;
      this.groups.forEach(function(group) {
        if (group.text === this.editing_item.group){
          this.editForm.group = group.value;
        }
      },this);
    },
  },
  created() {
    this.take_groups();

  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal-edit-contact'){
        this.initForm();
      }
    })
  },
};
</script>

<style scoped>

</style>
